import React from 'react';
import {
  CallStatusTag,
  CallStatus,
} from '@rsos/components/capstone/Queue/EmergencyCall/EmergencyCall.styles';
import { getCallStatusName } from '@rsos/components/capstone/Queue/EmergencyCall/helpers';
import { Box, Text } from '@rsos/components/capstone/base';
import { formatPhoneWithDashes } from '@rsos/utils';
import { convertUnixTimestamp } from '@rsos/utils/timeHelpers';
import { getDataSource } from '../../../../Location/helpers';

/**
 * Component for rendering call data in a popup. Currently only used for Esri
 * @param {Object} popupData
 * @param {Object} popupData.callData - callQueue[callerID].core.locations[idx] data
 * @param {String} popupData.callStatus - callQueue[callerID].callStatuses data
 * @param {Boolean} isInternational - is international support enabled
 */
const CallPopup = ({ isAllView, popupData, isInternational }) => {
  const callerID = popupData.callData.caller_id;

  const formattedCallerID = isInternational
    ? callerID
    : formatPhoneWithDashes(callerID);

  const source = getDataSource(popupData.callData);

  const callStatus = popupData.callStatus;

  const callStatusDisplayName = getCallStatusName(callStatus);

  return (
    <Box>
      <Text marginBottom="5px" size="large" fontWeight="bold">
        {formattedCallerID}
      </Text>
      <Text marginBottom="5px" size="large">
        {convertUnixTimestamp(Number(popupData.callData.call_start_time), true)}
      </Text>
      {callStatusDisplayName && (
        <CallStatusTag status={callStatus} isCallPopup={true}>
          <CallStatus status={callStatus}>{callStatusDisplayName}</CallStatus>
        </CallStatusTag>
      )}
      {!isAllView && <Text size="small">Source: {source}</Text>}
    </Box>
  );
};

export default CallPopup;
